'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;

var _numberIsFinite = require('./numberIsFinite');

var _numberIsFinite2 = _interopRequireDefault(_numberIsFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a value is a number
 *
 * @name isNumber
 * @param param Value that will be checked if it is a number
 * @returns {boolean} Returns true when param is a Number otherwise false
 */
function isNumber(param) {
  return typeof param === 'number' && (0, _numberIsFinite2.default)(param);
}
//# sourceMappingURL=isNumber.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isNumber.js
 ** module id = 46
 ** module chunks = 0 1
 **/